module.exports = __webpack_public_path__ + "static/so-hot-right-now-e210597d763940979b5fe42237b4b11d.mp4";